import * as React from "react";

import { UnitProps } from "../Unit/Unit";
import { UnitContainer } from "../Unit/UnitContainer";
import { UnitId } from "../Unit/UnitId/UnitId";
import { IForm } from "../../../Engine/Form/IForm";
import { useFormObject } from "../../FormObjectProvider";

import { IUnitNavigator } from "./IUnitNavigator";
import { UnitRegistryProvider } from "./UnitRegistry/UnitRegistryContext";
import { IUnitRegistry } from "./UnitRegistry/IUnitRegistry";
import { UnitRegistry } from "./UnitRegistry/UnitRegistry";
import { UnitPartialRenderer } from "./UnitPartialRendering/UnitPartialRenderer";

export interface NavigationProps {
    form: IForm;
    children?: React.ReactElement<UnitProps, typeof UnitContainer>;
    maxUnitsCount?: number;
}

export function Navigation(props: NavigationProps): JSX.Element {
    const [unitRegistry] = React.useState<IUnitRegistry>(() => new UnitRegistry());
    const hardcoreNavigation = React.createRef<IUnitNavigator>();
    const form = useFormObject();

    const scrollToUnit = React.useCallback(async (unitId: UnitId): Promise<void> => {
        await hardcoreNavigation.current?.scrollToUnit(unitId);
    }, []);

    React.useEffect(() => {
        form.unitNavigator = {
            scrollToUnit: scrollToUnit,
        };
    }, [scrollToUnit, unitRegistry]);

    return (
        <UnitRegistryProvider unitRegistry={unitRegistry}>
            <UnitPartialRenderer
                unitRegistry={unitRegistry}
                maxUnitCount={props.maxUnitsCount ?? 15}
                ref={hardcoreNavigation}>
                {props.children}
            </UnitPartialRenderer>
        </UnitRegistryProvider>
    );
}
